console.log('Quiz results page.');

function filterSlides(value1, value2) {
    let slides = document.querySelectorAll('#resultsSlider .swiper-slide');
    let title = document.getElementById('resultText');

    slides.forEach(slide => {
        if (value2) {
            //title.querySelector('span').innerText = `You're a ${value1} and ${value2} Lover!`

            switch (true) {
                case (value1 == 'Sweet & Salty' && value2 == 'Spice' || value2 == 'Sweet & Salty' && value1 == 'Spice'):
                    title.querySelector('span').innerText = `Team Pep Step`;
                    break;
                case (value1 == 'Sweet & Salty' && value2 == 'Sweet Tooth' || value2 == 'Sweet & Salty' && value1 == 'Sweet Tooth'):
                    title.querySelector('span').innerText = `Team Honey Bunnies`;
                    break;
                case (value1 == 'Sweet & Salty' && value2 == 'Chocolate' || value2 == 'Sweet & Salty' && value1 == 'Chocolate'):
                    title.querySelector('span').innerText = `Team Lushy Lucy`;
                    break;
                case (value1 == 'Sweet & Salty' && value2 == 'Fruity' || value2 == 'Sweet & Salty' && value1 == 'Fruity'):
                    title.querySelector('span').innerText = `Team Jolly Jammers`;
                    break;
                case (value1 == 'Spice' && value2 == 'Sweet Tooth' || value2 == 'Spice' && value1 == 'Sweet Tooth'):
                    title.querySelector('span').innerText = `Team Baby Got Rack`;
                    break;
                case (value1 == 'Spice' && value2 == 'Chocolate' || value2 == 'Spice' && value1 == 'Chocolate'):
                    title.querySelector('span').innerText = `Team Red Hotties`;
                    break;
                case (value1 == 'Spice' && value2 == 'Fruity' || value2 == 'Spice' && value1 == 'Fruity'):
                    title.querySelector('span').innerText = `Team Tahiti Sweetie`;
                    break;
                case (value1 == 'Sweet Tooth' && value2 == 'Chocolate' || value2 == 'Sweet Tooth' && value1 == 'Chocolate'):
                    title.querySelector('span').innerText = `Team Loonie Spoonie`;
                    break;
                case (value1 == 'Sweet Tooth' && value2 == 'Fruity' || value2 == 'Sweet Tooth' && value1 == 'Fruity'):
                    title.querySelector('span').innerText = `Team Tarty Smarties`;
                    break;
                case (value1 == 'Chocolate' && value2 == 'Fruity' || value2 == 'Chocolate' && value1 == 'Fruity'):
                    title.querySelector('span').innerText = `Team Benny Berries`;
                    break;
                default:
                    title.querySelector('span').innerText = `You're a ${value1} and ${value2} Lover!`
            }

            console.log(slide.dataset.category, value1);
            if (slide.dataset.category != value1 && slide.dataset.category != value2) {
                slide.parentNode.removeChild(slide);
            }
        } else {
            switch (value1) {
                case 'Chocolate':
                    title.querySelector('span').innerText = `Team Kookie Lookie`;
                    break;
                case 'Fruity':
                    title.querySelector('span').innerText = `Team Fruity Patootie`;
                    break;
                case 'Sweet & Salty':
                    title.querySelector('span').innerText = `Team Flavor Savors`;
                    break;
                case 'Spice':
                    title.querySelector('span').innerText = `Team ThrillSqueekers`;
                    break;
                case 'Sweet Tooth':
                    title.querySelector('span').innerText = `Team Cake and Bake`;
                    break;
            }

            if (slide.dataset.category != value1) {
                slide.parentNode.removeChild(slide);
            }
        }

    });
}

function calculateHeight() {
    let slides = document.querySelectorAll('#resultsSlider .swiper-slide');
    let height = 0;

    slides.forEach(slide => {
        let text = slide.querySelector('h3');

        if (text.clientHeight > height) {
            height = text.clientHeight;
        }
    });

    slides.forEach(slide => {
        let text = slide.querySelector('h3');

        text.style.height = height + 'px';
    });
}

function filterSoldOutItems() {
    let slides = $('.swiper-wrapper .swiper-slide');

    slides.each(function () {
       if ($(this).find('[data-add-to-cart]').text().indexOf("Sold out") >= 0) {
           $(this).after(slides.last()).appendTo($('.swiper-wrapper'));
       }
    });
}

if (localStorage.getItem('quizStep') == 7) {
    let answers = [];
    let countedResults = {};

    for (let i = 2; i <= 8; i++) {
        answers.push(localStorage.getItem(`quizStepAnswer${i}`));
    }

    if (answers) {
        answers.forEach(element => {
            countedResults[element] = (countedResults[element] || 0) + 1;
        });
    }

    if (countedResults) {
        console.log(Object.values(countedResults)[0], Object.values(countedResults)[1], Object.values(countedResults)[0] == Object.values(countedResults)[1])
        if (Object.values(countedResults)[0] == Object.values(countedResults)[1]) {
            //doubled result
            console.log('doubled');

            let currentFirstValue = Object.keys(countedResults)[0];
            let currentSecondValue = Object.keys(countedResults)[1];

            filterSlides(currentFirstValue, currentSecondValue);
        } else {
            //single result
            console.log('single');

            let currentValue = Object.keys(countedResults)[0];

            filterSlides(currentValue);
        }
    }
} else {
    window.location.href = '/pages/quiz-start';
}

document.addEventListener('DOMContentLoaded', () => {
        filterSoldOutItems();

        let slider = new Swiper(".swiper", {
            navigation: {
                nextEl: ".swiper-button-next-custom",
                prevEl: ".swiper-button-prev-custom",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 32,
                    pagination: {
                        el: ".swiper-pagination",
                    },
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                    pagination: false
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                    pagination: false
                },
                1360: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                    pagination: false
                },
                1400: {
                    slidesPerView: 4,
                    spaceBetween: 32,
                    pagination: false
                }
            },
            loop: false,
        });

        setTimeout(() => {
            calculateHeight();
        }, 300);

    if (window.innerWidth < 569) {
        slider.destroy();

        let style = document.createElement('style');
        style.innerHTML = `
          .swiper-wrapper {
            justify-content: center;
            flex-direction: column;
          }
          .swiper-pagination {
            display: none !important;
          }
          .swiper-slide {
            margin-bottom: 24px;
          }
        `;

        document.head.appendChild(style);
    }

    let btn = document.querySelector('#quizAgain');

    if (btn) {
        btn.addEventListener('click', e => {
           e.preventDefault();

            localStorage.setItem('quizStepAnswer1', '')
            localStorage.setItem('quizStepAnswer2', '')
            localStorage.setItem('quizStepAnswer3', '')
            localStorage.setItem('quizStepAnswer4', '')
            localStorage.setItem('quizStepAnswer5', '')
            localStorage.setItem('quizStepAnswer6', '')
            localStorage.setItem('quizStepAnswer7', '')
            localStorage.setItem('quizStepAnswer8', '')
            localStorage.setItem('quizStep', '1');

           window.location.href = '/pages/quiz-start';
        });
    }
});